<template>
  <div class="flex space-x-10 2xl:text-4xl text-3xl slit-in-diagonal-1">
    <div>
      <a href="https://twitter.com/ahmedalmory99" target="_blank"
        ><i class="fab fa-twitter-square text-gray-800 dark:text-blueGray-300 dark:hover:text-turquoise hover:text-turquoise"></i
      ></a>
    </div>
    <div>
      <a href="https://ma.linkedin.com/in/ahmedalmory" target="_blank"
        ><i class="fab fa-linkedin text-gray-800 dark:text-blueGray-300 dark:hover:text-turquoise hover:text-turquoise"></i
      ></a>
    </div>
    <div>
      <a href="https://github.com/ahmedalmory" target="_blank"
        ><i class="fab fa-github-square text-gray-800 dark:text-blueGray-300 dark:hover:text-turquoise hover:text-turquoise"></i
      ></a>
    </div>
    <div>
      <a href="https://telegram.me/ahmedalmory" target="_blank">
        <i class="fab fa-telegram-plane text-gray-800 dark:text-blueGray-300 dark:hover:text-turquoise hover:text-turquoise"></i></a>
    </div>
  </div>
</template>

<script>
export default {
    name:'VLinks'
};
</script>
